import React from 'react';
import { translate } from 'react-jhipster';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, Grid, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export const CertExistsConfirmationDialog = ({ open, onClose }) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle></DialogTitle>
      <DialogContent>
        <Grid sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: 'absolute',
              top: 10,
            }}
          >
            <CloseIcon />
          </IconButton>
        </Grid>
        &nbsp;
        {
          <DialogContentText style={{ color: 'black' }} className="mb-3">
            {translate('comexApp.quotation.certExisted')}
          </DialogContentText>
        }
      </DialogContent>
      <DialogActions className="mx-3 mb-3">
        <Button onClick={onClose}>{translate('comexApp.quotation.cancelBtnLabel')}</Button>
      </DialogActions>
    </Dialog>
  );
};
